import React, { useState } from 'react'
import { Button, Col, Form, Input, FormFeedback, Row, Label } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';



export const ModalUpdateMethod = (props) => {

    const {
        modalPreviewUpdate,
        toggleModalUpdate,
        user_method,
        user_password_method,
        id_pay_method_method,
        handleInputChangeMethod,
        listPayMethod,
        validatePassword,
        aunthentication,
        loadingUpdateMethod,
        validPorcentejeSpecial,
        insan,
        onSelect,
        onClear,
        form,
        setForm,
        phersu
    } = props;

    let _valid_size = (validPorcentejeSpecial === insan || validPorcentejeSpecial === phersu) ? "Global-small-2" : "Global-small-v";


    return (
        <Dialog
            visible={modalPreviewUpdate}
            onHide={toggleModalUpdate}
            closable={false}
            maskClassName="custom-total-mask"
            headerStyle={{
                backgroundColor: '#0f172a',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0f172a', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            modal
            appendTo="self"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-credit-card-alt"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Autorización de método de pago
                            </div>


                        </div>

                    </div>
                </div>
            }

            className={`Global-dialog Global-dialog Global-blue ${_valid_size} `}
            draggable={false}
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <Button
                        disabled={loadingUpdateMethod}
                        color="secondary"
                        type="button"
                        onClick={validatePassword}
                    >
                        {
                            loadingUpdateMethod ? <>
                                <i className="fa fa-spinner fa-spin mr-1"></i>{"Actualizando..."}</>
                                :
                                "Autorizar"
                        }
                    </Button>
                    <Button
                        disabled={loadingUpdateMethod}
                        color="danger"
                        type="button"
                        onClick={toggleModalUpdate}
                    >
                        Cancelar
                    </Button>

                </div>
            }
        >
            {
                (validPorcentejeSpecial === insan || validPorcentejeSpecial === phersu) && <Form>
                    <Col sm="12">
                        <Row className="update-method-container">

                            {/* Carga de archivo */}
                            <Col lg="7" md="12" className="mb-3">
                                <div className="update-method-upload-card">

                                    <h6 className="update-method-title">
                                        <i className="fa fa-file-upload me-2"></i>
                                        Evidencia
                                    </h6>
                                    <div className="upload-zone-modern">


                                        <FileUpload
                                            name="file"
                                            accept="image/*,.pdf"
                                            customUpload
                                            onSelect={onSelect}
                                            //onClear={onClear}
                                            onRemove={onClear}

                                            chooseLabel="Seleccionar archivo"
                                            uploadLabel="Procesar"
                                            cancelLabel="Cancelar"
                                            className="modern-upload"
                                            maxFileSize={10000000}
                                            emptyTemplate={
                                                <div className="update-method-empty">
                                                    <i className="pi pi-upload update-method-empty-icon"></i>

                                                    <p>
                                                        Arrastra un archivo aquí o selecciona uno.
                                                    </p>

                                                    <small>
                                                        Formatos permitidos:
                                                        JPG, PNG, JPEG, WEBP y PDF
                                                    </small>
                                                </div>
                                            }
                                        />
                                        {form.preview && (
                                            <div className="update-method-preview">
                                                {form.type.startsWith("image/") ? (
                                                    <img
                                                        src={form.preview}
                                                        alt="preview"
                                                        className="update-method-preview-image"
                                                    />
                                                ) : (
                                                    <iframe
                                                        src={form.preview}
                                                        title="Vista previa"
                                                        className="update-method-preview-pdf"
                                                    />
                                                )}
                                            </div>
                                        )}

                                        {/* {preview && (
                                            <div className="update-method-preview">
                                                {type.startsWith("image/") ? (
                                                    <img
                                                        src={preview}
                                                        alt="preview"
                                                        className="update-method-preview-image"
                                                    />
                                                ) : (
                                                    <iframe
                                                        src={preview}
                                                        title="Vista previa"
                                                        className="update-method-preview-pdf"
                                                    />
                                                )}
                                            </div>
                                        )} */}
                                    </div>


                                </div>
                            </Col>

                            {/* Observaciones */}
                            <Col lg="5" md="12" className="pt-2">


                                <h6 className="update-method-title">
                                    <i className="fa fa-comment-medical me-2"></i>
                                    Observaciones
                                </h6>

                                <Input
                                    type="textarea"
                                    rows="15"
                                    placeholder="Escriba las observaciones relacionadas con la autorización..."
                                    className="update-method-textarea"
                                    value={form.observations}
                                    onChange={(e) =>
                                        setForm(prev => ({
                                            ...prev,
                                            observations: e.target.value
                                        }))
                                    }
                                    invalid={
                                        (validPorcentejeSpecial === insan || validPorcentejeSpecial === phersu) &&
                                        form.observations.trim() === ""
                                    }
                                />
                                {(validPorcentejeSpecial === insan || validPorcentejeSpecial === phersu) &&
                                    form.observations.trim() === "" && (
                                        <FormFeedback>
                                            La observación es obligatoria para realizar este movimiento.
                                        </FormFeedback>
                                    )}

                                <h6 className="update-method-title pt-2">
                                    <i className="fa fa-comment-medical me-2"></i>
                                    Autorización
                                </h6>


                                <Row className="g-3 mb-3 pt-2">
                                    <Col md="6">
                                        <Label className="form-label-sm">Usuario</Label>
                                        <Input
                                            type="text"
                                            name="user_method"
                                            value={user_method}
                                            autoComplete="off"
                                            onChange={handleInputChangeMethod}
                                            className={`form-control form-control-sm custom-input ${aunthentication ? 'border-danger' : 'border-primary'
                                                }`}
                                        />
                                        <FormFeedback>Escribe el usuario</FormFeedback>
                                    </Col>

                                    <Col md="6">
                                        <Label className="form-label-sm">Contraseña</Label>
                                        <Input
                                            type="password"
                                            name="user_password_method"
                                            value={user_password_method}
                                            autoComplete="off"
                                            onChange={handleInputChangeMethod}
                                            className={`form-control form-control-sm custom-input ${aunthentication ? 'border-danger' : 'border-primary'
                                                }`}
                                        />
                                        <FormFeedback>Escribe la contraseña</FormFeedback>
                                    </Col>

                                    <Col md="12">
                                        <Label className="form-label-sm">Método de Pago</Label>
                                        <Input
                                            type="select"
                                            name="id_pay_method_method"
                                            value={id_pay_method_method}
                                            onChange={handleInputChangeMethod}
                                            className="form-control form-control-sm custom-input border-primary"
                                        >
                                            <option value={0}>Selecciona una opción</option>
                                            {
                                                listPayMethod.map(_pMethod => (
                                                    <option
                                                        value={_pMethod.id_pay_method}
                                                        key={`method-${_pMethod.id_pay_method}`}
                                                    >
                                                        {_pMethod.abbreviation} - {_pMethod.name}
                                                    </option>
                                                ))
                                            }
                                        </Input>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>

                    </Col>

                </Form>
            }
            {
                (validPorcentejeSpecial !== insan && validPorcentejeSpecial !== phersu) && <Form className="theme-form" role="form">
                    <Row className="align-items-stretch">
                        <Col md="3" className="d-flex justify-content-center align-items-center border-end">
                            <div className="side-lock-wrapper-2">
                                <img
                                    src={require("../../assets/images/blog/password.svg")}
                                    alt="user"
                                    className="side-lock-icon"
                                />
                            </div>
                        </Col>

                        <Col md="9">
                            <Row className="g-3 mb-3 pt-2">
                                <Col md="6">
                                    <Label className="form-label-sm">Usuario</Label>
                                    <Input
                                        type="text"
                                        name="user_method"
                                        value={user_method}
                                        autoComplete="off"
                                        onChange={handleInputChangeMethod}
                                        className={`form-control form-control-sm custom-input ${aunthentication ? 'border-danger' : 'border-primary'
                                            }`}
                                    />
                                    <FormFeedback>Escribe el usuario</FormFeedback>
                                </Col>

                                <Col md="6">
                                    <Label className="form-label-sm">Contraseña</Label>
                                    <Input
                                        type="password"
                                        name="user_password_method"
                                        value={user_password_method}
                                        autoComplete="off"
                                        onChange={handleInputChangeMethod}
                                        className={`form-control form-control-sm custom-input ${aunthentication ? 'border-danger' : 'border-primary'
                                            }`}
                                    />
                                    <FormFeedback>Escribe la contraseña</FormFeedback>
                                </Col>

                                <Col md="12">
                                    <Label className="form-label-sm">Método de Pago</Label>
                                    <Input
                                        type="select"
                                        name="id_pay_method_method"
                                        value={id_pay_method_method}
                                        onChange={handleInputChangeMethod}
                                        className="form-control form-control-sm custom-input border-primary"
                                    >
                                        <option value={0}>Selecciona una opción</option>
                                        {
                                            listPayMethod.map(_pMethod => (
                                                <option
                                                    value={_pMethod.id_pay_method}
                                                    key={`method-${_pMethod.id_pay_method}`}
                                                >
                                                    {_pMethod.abbreviation} - {_pMethod.name}
                                                </option>
                                            ))
                                        }
                                    </Input>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            }
        </Dialog >

    )
}
